import VacancyApi from '@/api/vacancy.js';
import averageTime from './widgets/averageTime.js';
import conversion from './widgets/conversion.js';
import totalInterviewDuration from './widgets/totalInterviewDuration.js';
import pieChart from './widgets/pieChart.js';
import funnel from './widgets/funnel.js';

import recruiters from './recruiters.js';
import vacancies from './vacancies.js';

import Moment from 'moment';

// const state = {
//   vacancies: [],
//   filters: {
//     vacancy: null,
//     user: null,
//     createdBefore: Moment().startOf('day'),
//     createdAfter: Moment().startOf('day').subtract(7, 'days')
//   }
// };

const getDefaultState = () => {
  return {
    vacancies: [],
    filters: {
      vacancy: null,
      user: null,
      createdBefore: Moment().startOf('day'),
      createdAfter: Moment().startOf('day').subtract(7, 'days')
    }
  };
};

const state = getDefaultState();

const actions = {
  async fetch({ commit, dispatch }) {
    commit('fetch');
    let filter = [];
    filter['active'] = true;

    return await VacancyApi.fetchList({ filter, is_accessible: false })
      .then(response => {
        let { data } = response;
        commit('fetchSuccess', data);
      })
      .catch(err => {
        dispatch('global/setError', err, { root: true });
        commit('fetchFailure', err);
        return Promise.reject(err);
      });
  }
};

const mutations = {
  filtersChange(state, val) {
    console.log(val);
    let keys = Object.keys(val);
    keys.forEach(i => {
      state.filters[i] = val[i];
    });
  },

  fetch(state) {
    state.loading = true;
  },

  fetchSuccess(state, data) {
    state.vacancies = data;
    state.loading = false;
  },

  fetchFailure(state, err) {
    state.error = err;
    console.error(err);
  }
};

const getters = {
  vacancies: state => state.vacancies,
  selectedVacancy: state => state.filters.vacancy,
  selectedUser: state => state.filters.user,
  createdBefore: state => state.filters.createdBefore,
  createdAfter: state => state.filters.createdAfter,
  filters: state => state.filters
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
  modules: {
    averageTime,
    conversion,
    totalInterviewDuration,
    pieChart,
    funnel,
    recruiters,
    vacancies
  }
};
